import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function TitlePlaceholder() {
  return (
    <Component>
      <TitleItem />
      <TitleItem />
      <TitleItem />
      <TitleItem />
    </Component>
  );
}

export default TitlePlaceholder;

const Component = styled.div`
  display: flex;
  padding-bottom: 25px;

  ${media.tablet(css`
    display: none;
  `)}
`;

const TitleItem = styled.div`
  width: 160px;
  height: 21.6px;
  border-radius: 8px;
  margin-right: 30px;
  ${placeholderAnimationCss}
`;
